import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const useIdle = () => {
  const [lastUserActionTime, setlastUserActionTime] = useState(Date.now());

  const callback = useDebouncedCallback(setlastUserActionTime, 1000);

  useEffect(() => {
    const mark = () => callback(Date.now());
    document.addEventListener('click', mark);
    document.addEventListener('keydown', mark);
  }, [callback]);

  return { lastUserActionTime };
};
